import React from "react"
import { twMerge } from "tailwind-merge"

export default function Spinner({ className = "", size = 32 }) {
  return (
    <div className={twMerge("w-full flex items-center justify-center py-12", className)}>
      <div
        className="rounded-full border-2 border-primary border-t-transparent animate-spin"
        style={{ width: size, height: size }}
      />
    </div>
  )
}
